import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { defineCustomElements } from "@craft-design-system/core-components/loader";
import "@craft-design-system/core-components/dist/core-components/core-components.css";

defineCustomElements();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
